import { IoMdImages } from "react-icons/io";
import {
  ChangeImageButton,
  Container,
  Image,
  NoImageContainer,
  NoImageText,
} from "./styles";
import { useState } from "react";
import BaseSection from "../BaseSection";
import { SURVEY_FORM_FIELDS } from "../../../constants";

export default function TopImageSection({ values, onChangeValue }) {
  const imageUrl = values[SURVEY_FORM_FIELDS.TOP_IMAGE_URL];

  const [previewImageUrl, setPreviewImageUrl] = useState(imageUrl);


  const handleChangeImageFile = (e) => {
    const image = e.target.files[0];

    if (!image) {
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      setPreviewImageUrl(reader.result);
      onChangeValue(SURVEY_FORM_FIELDS.TOP_IMAGE_FILE, image);
    };

    reader.readAsDataURL(image);
  };

  return (
    <BaseSection customPadding="0px">
      <Container>
        {previewImageUrl && <Image src={previewImageUrl} />}
        {!previewImageUrl && (
          <NoImageContainer>
            <IoMdImages size="2.25em" />
            <NoImageText>Selecione uma imagem, em "Alterar imagem"</NoImageText>
          </NoImageContainer>
        )}
        <ChangeImageButton>
          <input
            type="file"
            style={{ display: "none" }}
            accept="image/*"
            onChange={handleChangeImageFile}
          />
          Alterar imagem
        </ChangeImageButton>
      </Container>
    </BaseSection>
  );
}
